import { AggregatedLineItemGroupMutation } from 'Invoices/types'
import { toLineItem } from '../../common/adapters'
import { FormState } from './state.atoms'
import { filterPlaceholderSubItem } from './fields'

export const formStateToLineItemGroup = (
  state: FormState
): AggregatedLineItemGroupMutation => {
  const subItems = filterPlaceholderSubItem(state.subItems)

  return {
    id: crypto.randomUUID(),
    title: state.title,
    taxCategoryId: state.taxCategoryId,
    description: state.descriptionEnabled ? state.description : '',
    revenueRecognitionMethod: state.revenueRecognitionMethod,
    revenueClassification: state.revenueClassification,
    lineItems: [
      ...(state.subItemsEnabled
        ? subItems.map(subItem =>
            toLineItem({
              id: undefined,
              title: subItem.title,
              quantity: subItem.quantity,
              rate: subItem.rate,
              rateDisplay: state.rateDisplay,
              servicePeriod: state.servicePeriod,
              revenueRecognitionMethod: state.revenueRecognitionMethod,
              revenueClassification: state.revenueClassification,
              taxCategoryId: state.taxCategoryId,
              descriptionEnabled: false,
              description: '',
              externalIds: state.externalIds,
              productId: state.productId,
              priceId: undefined,
              creditGrantId: undefined
            })
          )
        : [
            toLineItem({
              id: undefined,
              title: state.title,
              quantity: state.quantity,
              rate: state.rate,
              rateDisplay: state.rateDisplay,
              servicePeriod: state.servicePeriod,
              revenueRecognitionMethod: state.revenueRecognitionMethod,
              revenueClassification: state.revenueClassification,
              taxCategoryId: state.taxCategoryId,
              descriptionEnabled: false,
              description: '',
              externalIds: state.externalIds,
              productId: state.productId,
              priceId: undefined,
              creditGrantId: undefined
            })
          ]),
      ...(state.discountEnabled
        ? [
            toLineItem({
              id: undefined,
              title: state.discount.title,
              quantity: '1',
              rate: `-${state.discount.amount}`,
              rateDisplay: 'ABSOLUTE',
              servicePeriod: state.servicePeriod,
              revenueRecognitionMethod: state.revenueRecognitionMethod,
              revenueClassification: state.revenueClassification,
              taxCategoryId: state.taxCategoryId,
              descriptionEnabled: false,
              description: '',
              externalIds: state.externalIds,
              productId: undefined,
              priceId: undefined,
              creditGrantId: undefined
            })
          ]
        : [])
    ]
  }
}
